import React, { useState } from 'react';
import Box from '../Box/Box';
import BookingFormModal from '../BookingFormModal/BookingFormModal';
import { rem } from 'polished';
import { Body1 } from '../Typography/Typography';
import ChevronRight from '../../images/icons/chevron-right.svg';
import { css } from 'styled-components';
import { track } from '../../utils/analytics';
import { getYoutubeIframeTag } from '../../utils/getYoutubeIframeTag';
import Button from '../Button/Button';

export const WatchAVideoButtonLink = ({
    videoEmbedUrl,
    text,
    trackingEvent,
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            <Button
                size="lg"
                variant="secondary"
                endIcon={<ChevronRight />}
                onClick={() => {
                    setIsModalOpen(true);
                    track(trackingEvent);
                }}
            >
                {text}
            </Button>
            {isModalOpen && (
                <BookingFormModal onClose={() => setIsModalOpen(false)}>
                    <BookingFormModal.FrameContainer
                        onClose={() => setIsModalOpen(false)}
                        dangerouslySetInnerHTML={{
                            __html: getYoutubeIframeTag(videoEmbedUrl),
                        }}
                    />
                </BookingFormModal>
            )}
        </>
    );
};
